import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const BORDER_COLOR = '#8A9EAF';
const BORDER_STYLE = 'solid';

const styles = StyleSheet.create({
  section__up: {
    paddingTop: 5,
    paddingBottom: 5,
    paddingRight: 10,
    // paddingLeft: 10,
    flexGrow: 1,
  },
  invoice__date: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderTopWidth: 0,
    borderRightWidth: 1,
    borderLeftWidth: 1,
    borderBottomWidth: 1,
  },
  invoice__date__Left: {
    flexDirection: 'row',
    // justifyContent: 'space-between',
    // flexGrow: 4,
    backgroundColor: 'rgba(231, 236, 244, .8)',
    flexWrap: 'wrap',
    paddingLeft: 10,
    width: '100%',
  },
  gray__text: {
    fontSize: 7,
    fontFamily: 'Roboto',
    fontWeight: '400',
  },
  gray__text_up: {
    fontSize: 7,
    fontFamily: 'Roboto',
    fontWeight: '600',
  },
  mr1: {
    // flexGrow: 1,
    alignItems: 'flex-start',
  },
});

export default function Total({ data = '', jobTotals, appliedTaxes }) {
  const { currencySymbol = '$', addCommasToNumber } = data;
  let {
    labourCharges = 0,
    partSupplyCost = 0,
    miscellaneousCharges = 0,
    discount = 0,
    totalTax = 0,
    totalCost = 0,
  } = data;

  labourCharges = addCommasToNumber(
    Math.round((+labourCharges || 0) * 100) / 100,
  );
  partSupplyCost = addCommasToNumber(
    Math.round((+partSupplyCost || 0) * 100) / 100,
  );
  miscellaneousCharges = addCommasToNumber(
    Math.round((+miscellaneousCharges || 0) * 100) / 100,
  );
  discount = addCommasToNumber(Math.round((+discount || 0) * 100) / 100);
  totalTax = addCommasToNumber(Math.round((+totalTax || 0) * 100) / 100);
  totalCost = addCommasToNumber(Math.round((+totalCost || 0) * 100) / 100);

  return (
    <>
      <View style={styles.invoice__date}>
        <View style={styles.invoice__date__Left}>
          {jobTotals?.Labor && (
            <View style={styles.mr1}>
              <View style={styles.section__up}>
                <Text style={styles.gray__text_up}>
                  Labor:{' '}
                  <Text style={styles.gray__text}>
                    {currencySymbol}
                    {labourCharges}
                  </Text>
                </Text>
              </View>
            </View>
          )}
          {jobTotals?.['Parts & Supplies'] && (
            <View style={styles.mr1}>
              <View style={styles.section__up}>
                <Text style={styles.gray__text_up}>
                  Parts & Supplies:{' '}
                  <Text style={styles.gray__text}>
                    {currencySymbol}
                    {partSupplyCost}
                  </Text>
                </Text>
              </View>
            </View>
          )}
          {jobTotals?.Miscellaneous && (
            <View style={styles.mr1}>
              <View style={styles.section__up}>
                <Text style={styles.gray__text_up}>
                  Miscellaneous:{' '}
                  <Text style={styles.gray__text}>
                    {currencySymbol}
                    {miscellaneousCharges}
                  </Text>
                </Text>
              </View>
            </View>
          )}
          {jobTotals?.Discount && (
            <View style={styles.mr1}>
              <View style={styles.section__up}>
                <Text style={styles.gray__text_up}>
                  Discount:{' '}
                  <Text style={styles.gray__text}>
                    {currencySymbol}
                    {discount}
                  </Text>
                </Text>
              </View>
            </View>
          )}
          {jobTotals?.Tax && (
            <View style={styles.mr1}>
              <View style={styles.section__up}>
                <Text style={styles.gray__text_up}>
                  Tax:{' '}
                  <Text style={styles.gray__text}>
                    {currencySymbol}
                    {totalTax}
                  </Text>
                </Text>
              </View>
            </View>
          )}
          {jobTotals?.Tax && (
            <>
              <Text
                style={{ fontSize: 7, fontWeight: 700, alignSelf: 'center' }}
              >
                (
              </Text>
              {appliedTaxes?.map((tax, i) => {
                return (
                  <View style={styles.mr1}>
                    <View
                      style={[
                        styles.section__up,
                        { paddingRight: 5, paddingLeft: 1 },
                      ]}
                    >
                      <Text style={[styles.gray__text_up]}>
                        {tax?.name}: {currencySymbol}
                        {addCommasToNumber(
                          Math.round((+tax?.calculatedTax || 0) * 100) / 100,
                        )}
                        {appliedTaxes?.length - 1 > i ? ',' : ''}
                        {/* <Text style={styles.gray__text}>
                      {currencySymbol}
                      {totalTax}
                    </Text> */}
                      </Text>
                    </View>
                  </View>
                );
              })}
              <Text style={{ fontSize: 7, alignSelf: 'center' }}>)</Text>
            </>
          )}
          {jobTotals?.['Total Amount'] && (
            <View style={[styles.mr1, { paddingLeft: 10 }]}>
              <View style={styles.section__up}>
                <Text style={styles.gray__text_up}>
                  Total Amount:{' '}
                  <Text style={styles.gray__text}>
                    {currencySymbol}
                    {totalCost}
                  </Text>
                </Text>
              </View>
            </View>
          )}
        </View>
      </View>
    </>
  );
}
